import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {Row, Col, Nav, NavItem, NavDropdown, MenuItem, Button, PageHeader, Popover, Overlay, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import {connectLoadingLock} from '../../core/redux/loading'
import {push} from '../../core/redux/router'
import extract from '../../core/extract'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import ReferencePatrimonyPopover from '../../patrimony/components/ReferencePatrimonyPopover'
import {REFERENCE_USER_CMD_TYPES, UPDATE_COMPANY_CMD_TYPES} from '../models'
import i18n from '../i18n'
import ReferenceSubsidiaryPopover from './ReferenceSubsidiaryPopover'
import ReferenceAgencyPopover from './ReferenceAgencyPopover'
import ReferenceUserPopover from './ReferenceUserPopover'
import UpdateCompanyPopover from './UpdateCompanyPopover'
import IdentifyCompanyPopover from './IdentifyCompanyPopover'
import ReactiveCancelCompanyModal from './ReactiveCancelCompanyModal'
import UpgradeDowngradePremiumAccountModal from './UpgradeDowngradePremiumAccountModal'
import UpgradeDowngradeStandardAccountModal from './UpgradeDowngradeStandardAccountModal'
import CompanyConfigsPopover from './CompanyConfigsPopover'
import style from './CompanyDetail.less'

function toLink(path) {
    return {
        active: path === '' ? location.pathname.split('/').length === 3 : location.pathname.endsWith(path),
        href: '/' + location.pathname.split('/').slice(1,3).join('/') + path
    }
}

function modalName(result) {
    switch (result) {
        case 'ReactiveCompany':
        case 'CancelCompany':
            return 'ReactiveCancelCompanyModal'
        case 'UpgradeCompanyToPremiumAccount':
        case 'DowngradePremiumAccount':
            return 'UpgradeDowngradePremiumAccountModal'
        case 'UpgradeCompanyToStandardAccount':
            return 'UpgradeDowngradeStandardAccountModal'
        default:
            return null
    }
}

class CompanyDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event, result) {
        if (event) {
            event.preventDefault()
        }
        
        const openedPopover = null
        const openedModal = modalName(result)
        this.setState({openedPopover, openedModal})
    }

    _closeModal(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedModal: null})
    }

    _openDropdown() {
        this.setState({openedDropdown: true})
    }

    _closeDropdown() {
        this.setState({openedDropdown: false})
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {children, dispatch, loading, location, authenticated, company, companyAgencies, companyUsers, companySubsidiaries, _appLinks, _patrimonyLinks} = this.props
        const {openedPopover, openedModal, openedDropdown} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {companySubsidiaries._links.find(linkFinder('CreateClientAccount')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferenceSubsidiaryPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.subsidiary}</span>
                            </a>
                        </li>
                    )}
                    {companyAgencies._links.find(linkFinder('CreateAgency')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferenceAgencyPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.agency}</span>
                            </a>
                        </li>
                    )}
                    {companyUsers._links.find(linkFinder(REFERENCE_USER_CMD_TYPES)) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferenceUserPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.user}</span>
                            </a>
                        </li>
                    )}
                    {_patrimonyLinks.find(linkFinder('ReferencePatrimony')) && company._links.find(linkFinder(['agencies', 'subsidiaries'])) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferencePatrimonyPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.patrimony}</span>
                            </a>
                        </li>
                    )}
                    {company._links.find(linkFinder('IdentifyCompany')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'IdentifyCompanyPopover')}>
                                <span>> {i18n.identifyCompany}</span>
                            </a>
                        </li>
                    )}
                    {company._links.find(linkFinder('configs')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'CompanyConfigsPopover')}>
                                <span>> {i18n.configs}</span>
                            </a>
                        </li>
                    )}
                    {company._links.find(linkFinder(UPDATE_COMPANY_CMD_TYPES)) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdateCompanyPopover')}>
                                <span>> {i18n.change}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={(e) => this._closePopover(e)}>
                {popover}
            </Overlay>
        )

        const tooltip = (text) => (
            <Tooltip>{text}</Tooltip>
        )

        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                            <div className={style.headerContent}>
                                <div className={style.container}>
                                    <span>{extract(i18n.companyTypeEnum, company.companyType)}</span>
                                    <span> {company.label}</span>
                                    {(company.billingType == 'PremiumAccount' || company.billingType == 'StandardAccount') && (
                                        <div className={style.billingType}>
                                            <OverlayTrigger
                                                placement='bottom'
                                                overlay={tooltip(extract(i18n.billingTypeEnum, company.billingType))}>
                                                <div className={style[company.billingType]} alt={company.billingType} title={company.billingType}>{company.billingType[0]}</div>
                                            </OverlayTrigger>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {companySubsidiaries._links.find(linkFinder('CreateClientAccount')) && editOverlay('ReferenceSubsidiaryPopover', (
                            <ReferenceSubsidiaryPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {companyAgencies._links.find(linkFinder('CreateAgency')) && editOverlay('ReferenceAgencyPopover', (
                            <ReferenceAgencyPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {companyUsers._links.find(linkFinder(REFERENCE_USER_CMD_TYPES)) && editOverlay('ReferenceUserPopover', (
                            <ReferenceUserPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {_patrimonyLinks.find(linkFinder('ReferencePatrimony')) && company._links.find(linkFinder(['agencies', 'subsidiaries'])) && editOverlay('ReferencePatrimonyPopover', (
                            <ReferencePatrimonyPopover
                                user={authenticated}
                                company={company}
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {company._links.find(linkFinder('IdentifyCompany')) && editOverlay('IdentifyCompanyPopover', (
                            <IdentifyCompanyPopover
                                onHide={(e, r) => this._closePopover(e, r)} />
                        ))}
                        {company._links.find(linkFinder('configs')) && editOverlay('CompanyConfigsPopover', (
                            <CompanyConfigsPopover
                                onHide={(e, r) => this._closePopover(e, r)} />
                        ))}
                        {company._links.find(linkFinder(UPDATE_COMPANY_CMD_TYPES)) && editOverlay('UpdateCompanyPopover', (
                            <UpdateCompanyPopover
                                onHide={(e, r) => this._closePopover(e, r)} />
                        ))}
                    </PageHeader>
                    <Row>
                        <Col sm={4} smOffset={4}>
                            {company._links.find(linkFinder('subsidiaries')) && (
                                <div className={style.metric}>
                                    <span>{i18n.subsidiaries}</span>
                                    <a href={toLink('/subsidiaries').href}>
                                        <Icon
                                            icon='ClientAccount'
                                            size='sm'
                                            count={companySubsidiaries.count} />
                                    </a>
                                </div>
                            )}
                            {company._links.find(linkFinder('agencies')) && (
                                <div className={style.metric}>
                                    <span>{i18n.agencies}</span>
                                    <a href={toLink('/agencies').href}>
                                        <Icon
                                            icon='agency'
                                            size='sm'
                                            count={companyAgencies.count} />
                                    </a>
                                </div>
                            )}
                            {company._links.find(linkFinder('users')) && (
                                <div className={style.metric}>
                                    <span>{i18n.users}</span>
                                    <a href={toLink('/users').href}>
                                        <Icon
                                            icon='user'
                                            size='sm'
                                            count={companyUsers.count} />
                                    </a>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem {...toLink('')}>
                            {i18n.synthesis}
                        </NavItem>
                        {company._links.find(linkFinder('subsidiaries')) && (
                            <NavItem {...toLink('/subsidiaries')}>
                                {i18n.subsidiaries}
                            </NavItem>
                        )}
                        {company._links.find(linkFinder('agencies')) && (
                            <NavItem {...toLink('/agencies')}>
                                {i18n.agencies}
                            </NavItem>
                        )}
                        {company._links.find(linkFinder('users')) && (
                            <NavItem {...toLink('/users')}>
                                {i18n.users}
                            </NavItem>
                        )}
                        {_appLinks.find(linkFinder('tickets')) && companyAgencies.length > 0 && (
                            <NavItem {...toLink('/tickets')}>
                                {i18n.tickets}
                            </NavItem>
                        )}
                        {(company.companyType == 'ClientAccountHolding' || company.companyType == 'ClientAccount') && (
                            <NavItem {...toLink('/documents')}>
                                {i18n.documents}
                            </NavItem>
                        )}
                        {_appLinks.find(linkFinder('providercontacts')) && (
                            <NavItem {...toLink('/providercontacts')}>
                                {i18n.providers}
                            </NavItem>
                        )}
                        <NavDropdown
                            className={cx({'active': [
                                    'openingticketpurposeref',
                                    'criteriaref',
                                    'contextualcommentref',
                                    'workflows',
                                    'criteriatrees',
                                    'openingticketinstructions',
                                    'satisfactioncampaigns',
                                    'notifications'
                                ].some(t => location.pathname.endsWith(t))
                            })}
                            title={i18n.parameters}
                            open={openedDropdown}
                            onToggle={() => null}
                            onMouseEnter={() => this._openDropdown()}
                            onMouseLeave={() => this._closeDropdown()}>
                            {company._links.find(linkFinder('openingticketpurposeref')) && (
                                <MenuItem {...toLink('/openingticketpurposeref')}>
                                    {i18n.openingticketpurposeref}
                                </MenuItem>
                            )}
                            {company._links.find(linkFinder('criteriaref')) && (
                                <MenuItem {...toLink('/criteriaref')}>
                                    {i18n.criteriaref}
                                </MenuItem>
                            )}
                            {company._links.find(linkFinder('workflows')) && (
                                <MenuItem {...toLink('/workflows')}>
                                    {i18n.workflows}
                                </MenuItem>
                            )}
                            {company._links.find(linkFinder('contextualcommentref')) && (
                                <MenuItem {...toLink('/contextualcommentref')}>
                                    {i18n.contextualcommentref}
                                </MenuItem>
                            )}
                            {company._links.find(linkFinder('criteriatrees')) && (
                                <MenuItem{...toLink('/criteriatrees')}>
                                    {i18n.qualifCriterias}
                                </MenuItem>
                            )}

                            <hr style={{margin: '5px 0'}} />

                            {company._links.find(linkFinder('openingticketinstructions')) && (
                                <MenuItem {...toLink('/openingticketinstructions')}>
                                    {i18n.openingticketinstructions}
                                </MenuItem>
                            )}
                            {company._links.find(linkFinder('ticketeventnotifications')) && (
                            <MenuItem {...toLink('/notifications')}>
                                {i18n.notifications}
                            </MenuItem>
                            )}
                            {company._links.find(linkFinder('satisfactioncampaigns')) && (
                                <MenuItem{...toLink('/satisfactioncampaigns')}>
                                    {i18n.satisfactioncampaigns}
                                </MenuItem>
                            )}

                        </NavDropdown>
                    </Nav>
                    {company._links.find(linkFinder(['ReactiveCompany', 'CancelCompany'])) && (
                        <ReactiveCancelCompanyModal
                            show={openedModal == 'ReactiveCancelCompanyModal'}
                            onHide={() => this._closeModal()} />
                    )}
                    {company._links.find(linkFinder(['UpgradeCompanyToPremiumAccount', 'DowngradePremiumAccount'])) && (
                        <UpgradeDowngradePremiumAccountModal
                            show={openedModal == 'UpgradeDowngradePremiumAccountModal'}
                            onHide={() => this._closeModal()} />
                    )}
                    {company._links.find(linkFinder('UpgradeCompanyToStandardAccount')) && (
                        <UpgradeDowngradeStandardAccountModal
                            show={openedModal == 'UpgradeDowngradeStandardAccountModal'}
                            onHide={() => this._closeModal()} />
                    )}
                </div>
                {children}
            </div>
        )
    }
}

CompanyDetail = connectLoadingLock()(CompanyDetail)

CompanyDetail = connect((state) => ({
    loading: state.loading,
    location: state.router.location,
    authenticated: state.user.authenticated,
    company: state.company.company,
    companyAgencies: state.company.companyAgencies,
    companyUsers: state.company.companyUsers,
    companySubsidiaries: state.company.companySubsidiaries,
    _appLinks: state.app._links,
    _patrimonyLinks: state.patrimony._links
}))(CompanyDetail)

export default CompanyDetail


// WEBPACK FOOTER //
// ./lib/company/components/CompanyDetail.js